<template>
  <HeadlessRadioGroup>
    <HeadlessRadioGroupLabel v-if="label">
      {{ label }}
    </HeadlessRadioGroupLabel>

    <div
      class="flex flex-nowrap items-stretch justify-between space-x-1 rounded-md border border-background-fg/6 p-0.5"
      :class="
        selectedOptionColor === 'background'
          ? 'bg-background-fg/5'
          : 'bg-background'
      "
    >
      <HeadlessRadioGroupOption
        v-for="option in options"
        :key="option.label"
        as="template"
      >
        <div
          :class="[
            option.value === modelValue
              ? selectedOptionColor === 'background'
                ? 'bg-background shadow-sm'
                : 'bg-primary text-white'
              : '',
            textSize === 'xs' ? 'text-xs' : 'text-sm',
            'flex-1 cursor-pointer rounded p-1 text-center',
          ]"
          @click="modelValue = option.value"
        >
          <HeadlessRadioGroupLabel
            as="span"
            class="line-clamp-1"
          >
            {{ option.label }}
          </HeadlessRadioGroupLabel>
        </div>
      </HeadlessRadioGroupOption>
    </div>
  </HeadlessRadioGroup>
</template>

<script
  setup
  lang="ts"
  generic="TValue extends string | number | boolean"
>
const {
  selectedOptionColor = "background",
  textSize = "xs",
} = defineProps<{
  label?: string
  options: readonly [Option<TValue>, Option<TValue>]
  selectedOptionColor?: "background" | "primary"
  textSize?: "xs" | "sm"
}>()

const modelValue = defineModel<TValue>({ required: true })
</script>
